import { render } from "./FormCity.vue?vue&type=template&id=47e0f984&scoped=true"
import script from "./FormCity.vue?vue&type=script&lang=js"
export * from "./FormCity.vue?vue&type=script&lang=js"

import "./FormCity.vue?vue&type=style&index=0&id=47e0f984&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\wwwda\\OneDrive\\Desktop\\проекты-и-учебные-файлы-front\\pizzares\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e0f984"]])

export default __exports__